import { StoreFilters, StoreItem, StoreSort } from '../models/store-rail.model';

const img = {
  herd: 'assets/images/im-home-img1.png',
  manes: 'assets/images/im-home-img2.png',
  lions: 'assets/images/im-home-img3.png',
  pride: 'assets/images/im-home-img4.png',
  moon: 'assets/images/Moonwharf.jpg',
  apo: 'assets/images/apothecary.jpg',
  black: 'assets/images/blackwater.jpg',
  ash: 'assets/images/Ashmorrow.jpeg',
  orb: 'assets/images/Orberia.jpeg',
  blu: 'assets/images/Bluendia.jpeg',
  waste: 'assets/images/poster-map.png',
};

/** Fixture catalog until the in-app store exists. Some slices are deliberately thin so Create fill-cards appear. */
export const STORE_CATALOG: StoreItem[] = [
  {
    id: 's1', title: 'Siege of the Iron-Hide Herd', image: img.herd, type: 'Campaign',
    author: 'Vessa Corr', world: 'Orberia', worldKey: 'orberia', rating: 4.8, reviews: 210,
    price: 14, playtimeHrs: 12, party: 'Lvl 5–8 · 4–5', gamesystem: 'Pathfinder 2e', biome: 'plains',
    publishedAt: '2026-09-01', desc: 'A migrating herd becomes a siege engine. Three-act campaign with a hard last stand.',
  },
  {
    id: 's2', title: 'Galloping Manes of Moonstride', image: img.manes, type: 'Adventure',
    author: 'Halloran', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.6, reviews: 88,
    price: 8, playtimeHrs: 4, party: 'Lvl 3–5 · 3–5', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-08-28', desc: 'Night-horses on the salt road. One evening, one bargain, one chase.',
  },
  {
    id: 's3', title: 'The Lions of Hollow Gate', image: img.lions, type: 'Adventure',
    author: 'Marek Sail', world: 'Bluendia', worldKey: 'bluendia', rating: 4.7, reviews: 134,
    price: 9, playtimeHrs: 5, party: 'Lvl 4–6 · 4–5', gamesystem: 'D&D 5e', biome: 'urban',
    publishedAt: '2026-08-22', desc: 'Stone lions wake when the tide-gate fails. A city-watch one-shot that runs long.',
  },
  {
    id: 's4', title: 'Pride of the Stone Guardians', image: img.pride, type: 'Mini Campaign / Adventure Arc',
    author: 'Odai Vrok', world: 'Vrokan Waste', worldKey: 'vrokan-waste', rating: 4.4, reviews: 41,
    price: 11, playtimeHrs: 8, party: 'Lvl 2–4 · 4–5', gamesystem: 'Pathfinder 2e', biome: 'desert',
    publishedAt: '2026-08-18', desc: 'Guardians of a dry river still take their oath seriously. You should not.',
  },
  {
    id: 's5', title: 'Moonwharf Market', image: img.moon, type: 'Establishment',
    author: 'Halloran', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.9, reviews: 302,
    price: 5, playtimeHrs: 2, party: 'Lvl 1–4 · 1–4', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-09-04', desc: 'Stalls, pickpockets, and a stall that sells maps of places that do not exist yet.',
  },
  {
    id: 's6', title: 'Brass Lantern Apothecary', image: img.apo, type: 'Establishment',
    author: 'Sella Wren', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.8, reviews: 176,
    price: 4, playtimeHrs: 2, party: 'Lvl 1–3 · 1–4', gamesystem: 'D&D 5e', biome: 'urban',
    publishedAt: '2026-09-03', desc: 'Remedies, poisons, and a debt the owner will not name.',
  },
  {
    id: 's7', title: 'Blackwater Traders\' Hall', image: img.black, type: 'Establishment',
    author: 'Torvild Ash', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.5, reviews: 91,
    price: 6, playtimeHrs: 3, party: 'Lvl 2–4 · 2–5', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-08-30', desc: 'A guild hall that still floods on the spring tide. Contracts are signed anyway.',
  },
  {
    id: 's8', title: 'The Drowned Bell', image: img.ash, type: 'Adventure',
    author: 'Halloran', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.9, reviews: 302,
    price: 9, playtimeHrs: 6, party: 'Lvl 4–6 · 4–5', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-07-12', desc: 'A flooded chapel rings on the hour and nobody will say why.',
  },
  {
    id: 's9', title: 'Tideglass Academy', image: img.blu, type: 'Establishment',
    author: 'Marek Sail', world: 'Bluendia', worldKey: 'bluendia', rating: 4.7, reviews: 154,
    price: 7, playtimeHrs: 3, party: 'Lvl 2–4 · 2–4', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-08-14', desc: 'A drowned school still takes pupils. Tuition is a secret.',
  },
  {
    id: 's10', title: 'Vaults of Sar Orin', image: img.orb, type: 'Adventure',
    author: 'Vessa Corr', world: 'Orberia', worldKey: 'orberia', rating: 4.6, reviews: 120,
    price: 10, playtimeHrs: 8, party: 'Lvl 3–6 · 3–6', gamesystem: 'Pathfinder 2e', biome: 'dungeon',
    publishedAt: '2026-08-02', desc: 'The royal vaults were sealed wet. They are not empty.',
  },
  {
    id: 's11', title: 'Salt, Rust and Ruin', image: img.waste, type: 'Adventure',
    author: 'Odai Vrok', world: 'Vrokan Waste', worldKey: 'vrokan-waste', rating: 4.6, reviews: 97,
    price: 7, playtimeHrs: 4, party: 'Lvl 2–4 · 4–5', gamesystem: 'D&D 5e', biome: 'desert',
    publishedAt: '2026-07-28', desc: 'Water is currency, the caravan is late, and something walks the dry riverbed.',
  },
  {
    id: 's12', title: 'Emberfall Barracks', image: img.orb, type: 'Establishment',
    author: 'Daybreak Collective', world: 'Orberia', worldKey: 'orberia', rating: 4.2, reviews: 38,
    price: 0, playtimeHrs: 2, party: 'Lvl 1–3 · 1–4', gamesystem: 'D&D 5e', biome: 'urban',
    publishedAt: '2026-09-06', desc: 'A free barracks drop-in. Drill sergeants, bunks, and a missing roster that keeps growing the longer anyone looks at it, because the quartermaster has been backdating the ledger since the spring muster and nobody wants to be the one who tells the captain.',
  },
  {
    id: 's13', title: 'Ash Bazaar Heist', image: img.waste, type: 'One Shot Encounter',
    author: 'Odai Vrok', world: 'Vrokan Waste', worldKey: 'vrokan-waste', rating: 4.3, reviews: 52,
    price: 0, playtimeHrs: 2, party: 'Lvl 3–5 · 3–4', gamesystem: 'Pathfinder 2e', biome: 'desert',
    publishedAt: '2026-09-05', desc: 'Steal the water-token before the bazaar closes. Ninety minutes, no mercy, and a dozen merchant guilds who will all remember your faces long after the heist is over and the bazaar reopens under new, much angrier management.',
  },
  {
    id: 's14', title: 'Wyrmspume Lighthouse', image: img.blu, type: 'Adventure',
    author: 'Marek Sail', world: 'Bluendia', worldKey: 'bluendia', rating: 4.5, reviews: 73,
    price: 8, playtimeHrs: 5, party: 'Lvl 3–5 · 3–5', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-08-08', desc: 'The lamp is lit for ships that should not arrive.',
  },
  {
    id: 's15', title: 'Salt Road Caravan', image: img.herd, type: 'Campaign',
    author: 'Halloran', world: 'Ashmorrow', worldKey: 'ashmorrow', rating: 4.4, reviews: 61,
    price: 16, playtimeHrs: 14, party: 'Lvl 5–8 · 4–6', gamesystem: 'Pathfinder 2e', biome: 'plains',
    publishedAt: '2026-06-20', desc: 'A season on the salt road. Keep the cargo, keep the party, keep the map.',
  },
  {
    id: 's16', title: 'Broken Halberd Outpost', image: img.waste, type: 'Campaign',
    author: 'Odai Vrok', world: 'Vrokan Waste', worldKey: 'vrokan-waste', rating: 4.1, reviews: 22,
    price: 12, playtimeHrs: 10, party: 'Lvl 4–6 · 4–6', gamesystem: 'D&D 5e', biome: 'desert',
    publishedAt: '2026-07-01', desc: 'Hold a fort that was never meant to last the dry season.',
  },
  {
    id: 's17', title: 'Gilded Sept Reliquary', image: img.orb, type: 'Side Quest',
    author: 'Vessa Corr', world: 'Orberia', worldKey: 'orberia', rating: 4.0, reviews: 19,
    price: 0, playtimeHrs: 2, party: 'Lvl 2–4 · 3–5', gamesystem: 'D&D 5e', biome: 'urban',
    publishedAt: '2026-09-07', desc: 'A relic walked out. Bring it back before vespers. Free to run, but the reliquary keeper swears the sept elders will not forgive a second disappearance, and the last party who tried this came back with fewer members than they left with.',
  },
  {
    id: 's18', title: 'Coral Vigil', image: img.blu, type: 'One Shot Encounter',
    author: 'Marek Sail', world: 'Bluendia', worldKey: 'bluendia', rating: 4.2, reviews: 28,
    price: 5, playtimeHrs: 2, party: 'Lvl 4–6 · 3–5', gamesystem: 'D&D 5e', biome: 'coast',
    publishedAt: '2026-08-26', desc: 'Stand a watch on living coral. The reef remembers who failed last time.',
  },
  {
    id: 's19', title: 'Hollowmere Docks', image: img.orb, type: 'Establishment',
    author: 'Vessa Corr', world: 'Orberia', worldKey: 'orberia', rating: 4.3, reviews: 44,
    price: 3, playtimeHrs: 2, party: 'Lvl 1–4 · 1–4', gamesystem: 'Pathfinder 2e', biome: 'coast',
    publishedAt: '2026-09-02', desc: 'Warehouses, night ferries, and a clerk who sells berth numbers twice.',
  },
  {
    id: 's20', title: 'Cartographer\'s Rest', image: img.orb, type: 'Establishment',
    author: 'Daybreak Collective', world: 'Orberia', worldKey: 'orberia', rating: 4.6, reviews: 80,
    price: 4, playtimeHrs: 2, party: 'Lvl 1–5 · 1–4', gamesystem: 'D&D 5e', biome: 'urban',
    publishedAt: '2026-08-11', desc: 'Maps, tea, and a back room where blank vellum is never blank for long.',
  },
];

export function filterStoreCatalog(catalog: StoreItem[], filters: StoreFilters): StoreItem[] {
  return catalog.filter((item) => {
    if (filters.type && item.type !== filters.type) return false;
    if (filters.types?.length && !filters.types.includes(item.type)) return false;
    if (filters.world && item.worldKey !== filters.world) return false;
    if (filters.biome && item.biome !== filters.biome) return false;
    if (filters.gamesystem && item.gamesystem !== filters.gamesystem) return false;
    if (filters.freeOnly && item.price !== 0) return false;
    if (filters.priceMax != null && item.price > filters.priceMax) return false;
    if (filters.playtimeMax != null && item.playtimeHrs > filters.playtimeMax) return false;
    if (filters.minRating != null && item.rating < filters.minRating) return false;
    if (filters.author && item.author !== filters.author) return false;
    return true;
  });
}

export function sortStoreCatalog(items: StoreItem[], sort: StoreSort): StoreItem[] {
  const copy = [...items];
  switch (sort) {
    case 'rating':
      return copy.sort((a, b) => b.rating - a.rating || b.reviews - a.reviews);
    case 'popular':
      return copy.sort((a, b) => b.reviews - a.reviews);
    case 'price':
      return copy.sort((a, b) => a.price - b.price);
    case 'newest':
    default:
      return copy.sort((a, b) => b.publishedAt.localeCompare(a.publishedAt));
  }
}
